import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import Navigation from "@/components/Navigation";
import Hero from "@/components/Hero";
import Services from "@/components/Services";
import About from "@/components/About";
import QuoteForm from "@/components/QuoteForm";
import Footer from "@/components/Footer";
import ServiceDetail from "@/pages/ServiceDetail";
import FAQ from "@/pages/FAQ";

const Landing = () => (
  <div className="App relative" data-testid="landing-root">
    <Navigation />
    <main>
      <Hero />
      <Services />
      <About />
      <QuoteForm />
    </main>
    <Footer />
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/services/:slug" element={<ServiceDetail />} />
        <Route path="/faq" element={<FAQ />} />
      </Routes>
      <Toaster
        position="top-center"
        richColors
        toastOptions={{
          style: {
            borderRadius: "9999px",
            background: "#1A3626",
            color: "#F7F6F2",
            border: "1px solid #234B35",
          },
        }}
      />
    </BrowserRouter>
  );
}

export default App;
